import { ReactNode } from "react";
import { Sparkles, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

type Variant = "default" | "onTint";

type Props = {
  children: ReactNode;
  className?: string;
  /**
   * Both variants render the canonical light-cyan pill. `variant` is retained
   * for API compatibility with existing call sites.
   */
  variant?: Variant;
  icon?: LucideIcon | false;
};

/**
 * Canonical eyebrow pill used above section H2s.
 * Light-cyan tint on all light backgrounds; icon is always fuchsia,
 * text is always ch-acai (dark purple) for consistency.
 * Hero pills on gradient backgrounds do NOT use this component.
 */
export const EyebrowPill = ({
  children,
  className,
  variant: _variant = "default",
  icon: Icon = Sparkles,
}: Props) => (
  <span
    className={cn(
      "inline-flex items-center gap-2 rounded-full font-carlito text-xs uppercase tracking-widest text-ch-acai px-4 py-1.5 mb-4",
      className,
    )}
    style={{ backgroundColor: "rgba(166, 241, 255, 0.4)" }}
  >
    {Icon && <Icon className="h-3.5 w-3.5 text-ch-fuchsia" strokeWidth={2.5} aria-hidden={true} />}
    {children}
  </span>
);

export default EyebrowPill;